import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { Logo } from '@/components/generals/logo'
import { Container } from '@/components/generals/container'
import { footerNav, siteConfig } from '@/constants/site'

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='mt-24 border-t border-white/[0.06] bg-surface/60'>
            <Container className='grid gap-12 py-14 md:grid-cols-[1.4fr_repeat(2,minmax(0,1fr))]'>
                <div className='max-w-sm space-y-4'>
                    <Link
                        href='/'
                        className='inline-flex rounded-lg focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none'
                    >
                        <Logo />
                        <span className='sr-only'>Home</span>
                    </Link>

                    <p className='font-heading text-2xl leading-snug text-foreground'>
                        {siteConfig.tagline}
                    </p>

                    <p className='text-sm leading-relaxed text-muted-foreground'>
                        Hand-picked backgrounds for every screen you own. Browse by mood, device or color, then download the full-size file in one click.
                    </p>
                </div>

                {footerNav.map(section => (
                    <nav key={section.title} aria-label={section.title}>
                        <h2 className='text-xs font-semibold tracking-[0.14em] text-muted-foreground uppercase'>
                            {section.title}
                        </h2>

                        <ul className='mt-4 space-y-3'>
                            {section.links.map(link => (
                                <li key={link.href}>
                                    <Link
                                        href={link.href}
                                        className='rounded text-sm text-foreground/80 transition-colors hover:text-foreground focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none'
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>
                ))}
            </Container>

            <div className='border-t border-white/[0.06]'>
                <Container className='flex flex-col gap-2 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between'>
                    <p>
                        ©
                        {' '}
                        <span suppressHydrationWarning>
                            {new Date().getFullYear()}
                        </span>
                        {' '}
                        {siteConfig.name}. Made for screens of every size.
                    </p>

                    <p>
                        Desktop and phone wallpapers, free to download.
                    </p>
                </Container>
            </div>
        </footer>
    )
}
